import { Component, input, output } from "@angular/core";
import { ButtonComponent } from "@odx/angular/components/button";
import { IconComponent } from "@odx/angular/components/icon";
import { TooltipDirective } from "@odx/angular/components/tooltip";

@Component({
  selector: "app-extend-button",
  imports: [ButtonComponent, IconComponent, TooltipDirective],
  templateUrl: "./extend-button.component.html",
  standalone: true,
})
export class ExtendButtonComponent {
  readonly isExtended = input.required<boolean>();
  readonly buttonClicked = output<void>();

  protected readonly tooltipTextExtendItem: string = $localize`:@@floorplan.button.extendItem:Zusätzliche Optionen ausklappen`;
  protected readonly tooltipTextCollapseItem: string = $localize`:@@floorplan.button.collapseItem:Zusätzliche Optionen einklappen`;
}
